import React from 'react';

const MessageReactionsContext = React.createContext({
  messagesCollectionPath: '',
});

export const MessageReactionsContextProvider = MessageReactionsContext.Provider;

export default MessageReactionsContext;
